// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3RDIN","content":"GlobalSearch_content__SWQPP"};